export default {
    goToFirstPage: 'Ir a la primera página',
    goToLastPage: 'Ir a la última página',
    goToNextPage: 'Ir a la página siguiente',
    goToPreviousPage: 'Ir a la página anterior',
    items: 'elementos',
    pageRange: '{x} - {y} de {z} elementos',
};
